// BTMultilineHTMLReader.tsx
import React from 'react';
import styled from 'styled-components';
import 'react-quill/dist/quill.snow.css';

interface BTMultilineHTMLReaderProps {
    html: string;
    borderColor?: string;
    width?: string;
    minHeight?: string;
}

const BTMultilineHTMLReader: React.FC<BTMultilineHTMLReaderProps> = ({
    html,
    borderColor = '#adb5bd',
    width = '100%',
    minHeight = '250px',
}) => {
    return (
        <StyledDiv $borderColor={borderColor} $width={width} $minHeight={minHeight}>
            <div className="ql-container ql-snow">
                <div className="ql-editor" dangerouslySetInnerHTML={{ __html: html }} />
            </div>
        </StyledDiv>
    );
};

export default BTMultilineHTMLReader;

const StyledDiv = styled.div<{
    $borderColor: string;
    $width: string;
    $minHeight: string;
}>`
    box-sizing: border-box;       /* ✅ 폭 계산을 테두리+패딩 포함으로 */
    max-width: 100%;              /* ✅ 혹시 모를 부모 초과 방지 */
    // border: 1px solid ${({ $borderColor }) => $borderColor};
    // border-radius: 4px;
    // padding: 10px;
    width: ${({ $width }) => $width};
    min-height: ${({ $minHeight }) => $minHeight};
    font-size: 16px;
    color: #232d42;
    background-color: transparent;
    line-height: 1.4;
    white-space: pre-wrap;
    word-wrap: break-word;

    // /* 컨테이너가 마지막에 떠 있는 요소들을 감싸도록 clearfix */
    // &::after {
    //     content: "";
    //     display: block;
    //     clear: both;
    // }

    // /* 이미지 정렬 스타일 */
    // .ql-align-center {
    //     text-align: center;
    // }

    // .ql-align-center img {
    //     display: block;
    //     margin-left: auto;
    //     margin-right: auto;
    // }

    // .ql-align-right {
    //     text-align: right;
    // }

    // .ql-align-right img {
    //     display: block;
    //     margin-left: auto;
    // }

    // .ql-align-left {
    //     text-align: left;
    // }

    // .ql-align-left img {
    //     display: block;
    //     margin-right: auto;
    // }

    // /* float된 이미지의 레이아웃 개선 - 더 구체적인 선택자 사용 */
    // img[style*="float: right"],
    // img[style*="float:right"] {
    //     float: right !important;
    //     margin-left: 10px;
    //     margin-bottom: 10px;
    //     margin-top: 0;
    //     display: block;
    // }

    // img[style*="float: left"],
    // img[style*="float:left"] {
    //     float: left !important;
    //     margin-right: 10px;
    //     margin-bottom: 10px;
    //     margin-top: 0;
    //     display: block;
    // }

    // /* 모든 이미지에 대한 기본 스타일 */
    // img {
    //     max-width: 100%;
    //     height: auto;
    // }

    // /* 떠 있는 자식(img, span 등)을 포함하는 문단은 높이 확보 */
    // p:has([style*="float"]) {
    //     min-height: auto;
    //     overflow: hidden; /* BFC 생성으로 float 내재화 */
    //     clear: both;
    // }

`;